<template>
  <b-card no-body>
    <b-card-header>
      <!-- title and subtitle -->
      <div>
        <b-card-title class="mb-1 font-weight-bolder">
          ${{ dFormatter(currentTVL) }}
        </b-card-title>
        <b-card-sub-title>Total TVL - History</b-card-sub-title>
      </div>
    </b-card-header>

    <!-- chart -->
    <b-card-body>
      <vue-apex-charts
        v-if="loaded"
        type="area"
        height="250"
        :options="apexChartData.metaPoolTvlAreaChart.chartOptions"
        :series="apexChartData.metaPoolTvlAreaChart.series"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardBody, BCardHeader, BCardTitle, BCardSubTitle, BCardText,
} from 'bootstrap-vue'
import { dFormatter } from '@core/utils/filter'
import VueApexCharts from 'vue-apexcharts'
import apexChartData from './apexChartData'
import axios from 'axios'

export default {
  components: {
    BCard,
    BCardBody,
    BCardHeader,
    BCardTitle,
    BCardSubTitle,
    BCardText,

    VueApexCharts,
  },
  data() {
    return {
      apexChartData,
      currentTVL: 0,
      loaded: false,
    }
  },
  methods: {
    dFormatter,
  },
  mounted () {
    this.loaded = false;
    const endpoint = `https://api.llama.fi/protocol/meta-pool`
    axios.get(endpoint)
    .then(response => {
      this.currentTVL = response.data["tvl"][response.data["tvl"].length - 1].totalLiquidityUSD
      apexChartData.metaPoolTvlAreaChart.series[0].data = []
      for (let datapoint in response.data["tvl"]){
        var x = new Date(response.data["tvl"][datapoint].date*1000)
        var y = response.data["tvl"][datapoint].totalLiquidityUSD
        apexChartData.metaPoolTvlAreaChart.series[0].data.push({
          x: x,
          y: y
        })
      }
      this.loaded = true;
    })
    .catch(e => {
      console.error(e)
    })
  }
}
</script>
<style>

</style>
